import { render, staticRenderFns } from "./problem.vue?vue&type=template&id=385131e6&scoped=true"
import script from "./problem.vue?vue&type=script&lang=js"
export * from "./problem.vue?vue&type=script&lang=js"
import style0 from "./problem.vue?vue&type=style&index=0&id=385131e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385131e6",
  null
  
)

export default component.exports